module.exports = __webpack_public_path__ + "assets/Crime.01287dd6.svg";